/*=========================================================================================
  File Name: moduleContact.js
  Description: Contact Module
  ----------------------------------------------------------------------------------------
  Author: Djezou Eric Martial
==========================================================================================*/


import state from './moduleContactState.js'
import mutations from './moduleContactMutations.js'
import actions from './moduleContactActions.js'
import getters from './moduleContactGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
